var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50590_29837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67855 8.99993C7.31438 8.99993 7.93593 8.81138 8.4646 8.45812C8.99326 8.10486 9.4053 7.60276 9.64859 7.01532C9.89189 6.42788 9.95552 5.78149 9.83143 5.15788C9.70735 4.53428 9.40112 3.96148 8.95148 3.51192C8.50185 3.06236 7.92899 2.75623 7.30536 2.63226C6.68174 2.50828 6.03535 2.57202 5.44796 2.81542C4.86056 3.05882 4.35853 3.47094 4.00537 3.99967C3.6522 4.5284 3.46376 5.14998 3.46387 5.78581C3.46476 6.63807 3.80376 7.45516 4.40645 8.05775C5.00914 8.66034 5.82629 8.99919 6.67855 8.99993Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8841 11.6556C10.0695 10.82 9.02428 10.2463 7.88203 10.0076C6.73977 9.76895 5.5523 9.8762 4.47129 10.3157C3.39029 10.7551 2.46482 11.5069 1.81311 12.4748C1.1614 13.4428 0.813027 14.5831 0.8125 15.75C0.8125 15.8992 0.871763 16.0423 0.977252 16.1478C1.08274 16.2533 1.22582 16.3125 1.375 16.3125H11.9838C12.1329 16.3125 12.276 16.2533 12.3815 16.1478C12.487 16.0423 12.5463 15.8992 12.5463 15.75C12.5484 15.1536 12.4564 14.5605 12.2734 13.9928C12.0011 13.1151 11.525 12.3142 10.8841 11.6556Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 9.28125C14.7891 9.28125 15.8594 8.21093 15.8594 6.89062C15.8594 5.57032 14.7891 4.5 13.4688 4.5C12.1484 4.5 11.0781 5.57032 11.0781 6.89062C11.0781 8.21093 12.1484 9.28125 13.4688 9.28125Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.469 9.93945C12.715 9.94229 11.9756 10.1476 11.3281 10.534C11.4502 10.6431 11.5734 10.7506 11.6887 10.8687C12.4546 11.6559 13.0236 12.6131 13.3492 13.6621C13.4607 14.0074 13.5429 14.3616 13.595 14.7207H17.1252C17.2744 14.7207 17.4175 14.6614 17.523 14.556C17.6285 14.4505 17.6877 14.3074 17.6877 14.1582C17.6866 13.0397 17.2417 11.9673 16.4508 11.1764C15.6599 10.3855 14.5875 9.94064 13.469 9.93945Z",
    fill: "#current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50590_29837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0101cb31dc25abdefb0ab7c45ebb68ed.svg";
export { ForwardRef as ReactComponent };